export default __webpack_public_path__ + "svg/banner/free.svg?307dd6f5";